export default [
  {
    route: '/',
    title: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard',
    // Ver o comentário em `navigation/vertical/dashboard.js`.
    hideForRoles: ['influencer']
  }
]
